function findCategoryAncestors(node, toFind, startingArray = []) {
  if (node === toFind) {
    return startingArray;
  }
  if (node.children && node.children.length > 0) {
    for (let i = 0; i < node.children.length; i += 1) {
      const subnode = node.children[i];
      const result = findCategoryAncestors(subnode, toFind, [...startingArray, subnode]);
      if (result)
        return result;
    }
  }
  return null;
}
export {
  findCategoryAncestors
};
